<ng-template #dpBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('address.save-address-first' | translate)
                : ('address.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'address.save-address-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #dpBlock
    [class]="'w-full'"
    [blocked]="!model?.id"
    [blockUi]="dpBlockUi"
>
    @if (model?.id) {
        <app-data-protection-widget [addressIdSig]="model.id" />
    }
</blockable-div>
